
export class PosicionNPModel {
    MovilId: number;
    Fecha: Date;
    Ignicion: boolean;
    Lat: number;
    Lng: number;
    Velocidad: number;
    Altura: number;
    Rumbo: number;
    Conexion: boolean;

    constructor(movilId: number, fecha: Date, ignicion: boolean, lat: number, lng: number,
        velocidad: number, altura: number, runbo: number, conexion: boolean) {
        this.MovilId = movilId;
        this.Fecha = fecha;
        this.Ignicion = ignicion;
        this.Lat = lat;
        this.Lng = lng;
        this.Velocidad = velocidad;
        this.Altura = altura;
        this.Rumbo = runbo;
        this.Conexion = conexion;
    }
}